import React, { useState } from 'react';
import { 
    useGetAdminUsersQuery,
    useUpdateAdminRoleMutation,
    useLazyExpiredIdenfyKYCQuery,
    usePostPaxumDataMutation,
    useLazyRunTest1Query
} from '../app/api';
import {
  Button,
  Alert,
  Form,
  Card,
  Container
} from 'react-bootstrap';

export default function Admin() {
  
  const { data: adminData, isLoading: isDataLoading, error, refetch } = useGetAdminUsersQuery();
  const [updateAdminRole] = useUpdateAdminRoleMutation();
  const [getExpiredKYC] = useLazyExpiredIdenfyKYCQuery();
  const [postPaxumData] = usePostPaxumDataMutation();
  const [dbtests] = useLazyRunTest1Query();
  const [updating, setUpdating] = useState({});
  const [message, setMessage] = useState(null);
  const [roleFilter, setRoleFilter] = useState('ALL');
  const [advGoToPage, setAdvGoToPage] = useState('/expired_docs');
  
  const admins = adminData?.admins || [];
  const filteredAdmins = roleFilter === 'ALL' ? admins : admins.filter(admin => admin.role === roleFilter);

  const handleAdvancedDevClick = async (type) => {
    if(type == 'expired kyc data'){
        const x = await getExpiredKYC();
        console.log(x.data);
    }
    if(type == 'run paxum api test'){
        const x = await postPaxumData({data: 'hello'});
        console.log(x.data);
    }
    if(type == 'run db tests'){
        const x = await dbtests({client_id: 'affiliate:1036812'});
        console.log(x.data);
    }
  }

  const handleRoleChange = async (uuid, newRole) => {
    const updateKey = `${uuid}-${newRole}`;
    setUpdating(prev => ({ ...prev, [updateKey]: true }));
    try {
      await updateAdminRole({ uuid, role: newRole }).unwrap();
      setMessage({ type: 'success', text: 'Role updated successfully' });
      refetch();
    } catch (error) {
      setMessage({ type: 'danger', text: 'Failed to update role' });
    } finally {
      setUpdating(prev => ({ ...prev, [updateKey]: false }));
    }
  };

  const getRoleBadgeClass = (role) => {
    switch (role) {
      case 'ADMIN': return 'bg-danger';
      case 'CS_ADMIN': return 'bg-info';
      case 'LEGAL': return 'bg-warning text-dark';
      case 'CS': return 'bg-primary';
      case 'PENDING': return 'bg-secondary';
      default: return 'bg-secondary';
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    return new Date(dateString).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  if (isDataLoading) {
    return (
      <div className="container-fluid py-4">
        <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '200px' }}>
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      </div>
    );
  }

  if (isDataLoading) {
    return (
      <div className="container-fluid py-4">
        <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '200px' }}>
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="container-fluid py-4">
        <Alert variant="danger">
          Error loading admin users. Please try again.
        </Alert>
      </div>
    );
  }

  return (
    <div className="container-fluid py-4">
      <div className="mb-4">
        <h4 className="mb-1">Admin User Management</h4>
      </div>

      {message && (
        <Alert 
          variant={message.type} 
          dismissible 
          onClose={() => setMessage(null)}
          className="mb-4"
        >
          {message.text}
        </Alert>
      )}

      <div className="card">
        <div className="card-header d-flex justify-content-between align-items-center">
          <h5 className="mb-0">Users ({filteredAdmins.length})</h5>
          <div className="d-flex align-items-center">
            <Form.Label className="me-2 mb-0">Filter by role:</Form.Label>
            <Form.Select
              size="sm"
              value={roleFilter}
              onChange={(e) => setRoleFilter(e.target.value)}
              style={{ width: '120px' }}
            >
              <option value="ALL">All Users</option>
              <option value="ADMIN">Admin</option>
              <option value="CS_ADMIN">CS Admin</option>
              <option value="LEGAL">Legal</option>
              <option value="CS">CS</option>
              <option value="PENDING">Pending</option>
            </Form.Select>
          </div>
        </div>
        <div className="table-responsive">
          <table className="table table-hover table-nowrap mb-0">
            <thead className="table-light">
              <tr>
                <th>Username</th>
                <th>Current Role</th>
                <th>Created</th>
                <th>Last Updated</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {filteredAdmins.map(admin => (
                <tr key={admin.uuid}>
                  <td>
                    <div className="fw-medium">{admin.username}</div>
                  </td>
                  <td>
                    <span className={`badge ${getRoleBadgeClass(admin.role)}`}>
                      {admin.role === 'CS_ADMIN' ? 'CS ADMIN' : admin.role}
                    </span>
                  </td>
                  <td>{formatDate(admin.created)}</td>
                  <td>{formatDate(admin.updated)}</td>
                  <td>
                    <div className="d-flex gap-2">
                      {['ADMIN', 'CS_ADMIN', 'LEGAL', 'CS', 'PENDING'].map(role => {
                        const updateKey = `${admin.uuid}-${role}`;
                        const isUpdating = updating[updateKey];
                        const displayRole = role === 'CS_ADMIN' ? 'CS ADMIN' : role;
                        return (
                          <Button
                            key={role}
                            variant={admin.role === role ? 'primary' : 'outline-primary'}
                            size="sm"
                            disabled={admin.role === role || isUpdating}
                            onClick={() => handleRoleChange(admin.uuid, role)}
                          >
                            {isUpdating ? (
                              <span className="spinner-border spinner-border-sm me-1" />
                            ) : null}
                            {displayRole}
                          </Button>
                        );
                      })}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* development functionality / testing */}
      <Container className='my-4'>
        <Card>
            <Card.Header>Advanced Development Features</Card.Header>
            <Card.Body>
                <Card.Title className='my-3'>Run Test</Card.Title>
                <Button variant="primary" onClick={ ()=> handleAdvancedDevClick('run db tests') }>Run</Button>
            </Card.Body>
            <Card.Body>
                <Card.Title className='my-3'>Go To Page:</Card.Title>
                <input type="text" id="adminGoTo" value={advGoToPage} onChange={(e)=>setAdvGoToPage(e.target.value)}/>
                <Button variant="primary" onClick={ ()=> window.location = advGoToPage }>GO</Button>
            </Card.Body>
        </Card>
      </Container>


    </div>
  );
} 
